(function () {
  'use strict';
  if (window.KCW) return;
  window.KCW = true;

  var doc = document;
  var ON = 'kcw-is-on', IN = 'kcw-is-in', ADDED = 'kcw-is-added';
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = null, shelf = 0, opener = null, toastTimer = null, fmt = null;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function bar() { return $('[data-kcw="bar"]'); }
  function layer() { return $('[data-kcw-layer]'); }
  function cfg(key, fallback) { var b = bar(); return (b && b.getAttribute('data-' + key)) || fallback || ''; }
  function approved() { var b = bar(); return !b || b.getAttribute('data-approved') === 'true'; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents) {
    if (!fmt) {
      try { fmt = new Intl.NumberFormat(cfg('locale', 'en'), { style: 'currency', currency: cfg('currency', 'USD') }); }
      catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
    }
    return fmt.format(cents / 100);
  }
  function fill(text, map) {
    return String(text || '').replace(/\[(\w+)\]/g, function (all, k) { return k in map ? map[k] : all; });
  }
  function request(path, body) {
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(base + path, opts).then(function (r) {
      return r.json().then(function (j) { return j; }, function () { return null; }).then(function (j) {
        if (!r.ok || !j) throw { shop: !!(j && j.status), description: j && (j.description || j.message) };
        return j;
      });
    }, function () { throw { shop: false }; });
  }

  function toast(message) {
    var t = $('[data-toast]', layer() || doc);
    if (!t) {
      var host = doc.createElement('div');
      host.className = 'kcw kcw-layer';
      host.setAttribute('data-kcw-layer', '');
      host.innerHTML = '<div class="kcw-toast" data-toast role="status" aria-live="polite"><span data-toast-text></span></div>';
      doc.body.appendChild(host);
      t = $('[data-toast]', host);
    }
    $('[data-toast-text]', t).textContent = message;
    t.classList.add(ON);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove(ON); }, 2800);
  }
  function flash(btn, label) {
    if (!btn || !label) return;
    var old = btn.textContent;
    btn.classList.add(ADDED);
    btn.textContent = label;
    setTimeout(function () {
      if (!btn.isConnected) return;
      btn.classList.remove(ADDED);
      if (btn.hasAttribute('data-add')) { var row = btn.closest('[data-row]'); if (row) updateRow(row); }
      else btn.textContent = old;
    }, 1300);
  }

  function lineName(item) {
    return item.product_title + (item.product_has_only_default_variant || !item.variant_title ? '' : ' ' + item.variant_title);
  }
  function countText(n) {
    return n === 1 ? cfg('count-one', '1 item') : fill(cfg('count-many', '[count] items'), { count: n });
  }
  function paint() {
    if (!cart) return;
    var b = bar(), l = layer(), n = cart.item_count;
    if (b && approved()) {
      var chips = $('[data-chips]', b);
      if (chips) {
        chips.innerHTML = cart.items.length
          ? cart.items.map(function (i) { return '<span><b>' + i.quantity + '×</b>' + esc(lineName(i)) + '</span>'; }).join('')
          : '<em>' + esc(cfg('empty')) + '</em>';
      }
      $$('[data-sub]').forEach(function (e) { if (e.closest('[data-kcw="bar"],[data-kcw-layer]')) e.textContent = money(cart.total_price); });
      $$('[data-count]').forEach(function (e) { if (e.closest('[data-kcw="bar"],[data-kcw-layer]')) e.textContent = countText(n); });
      $$('.kcw [data-checkout]').forEach(function (e) { if (n) e.removeAttribute('aria-disabled'); else e.setAttribute('aria-disabled', 'true'); });
      if (l) {
        var m = $('[data-mbar]', l);
        if (m) { m.classList.toggle(ON, n > 0); doc.body.classList.toggle('kcw-has-bar', n > 0); }
        var items = $('[data-items]', l);
        if (items) {
          items.innerHTML = cart.items.length ? cart.items.map(function (i) {
            var img = i.image ? '<img src="' + esc(i.image) + '" alt="" width="60" height="75" loading="lazy">' : '<span class="kcw-li__ph"></span>';
            return '<div class="kcw-li" data-li="' + esc(i.key) + '">' + img +
              '<div><b>' + esc(i.product_title) + '</b><span>' + (i.product_has_only_default_variant || !i.variant_title ? '' : esc(i.variant_title) + ' · ') + money(i.final_price) + '</span>' +
              '<div class="kcw-qty"><button type="button" data-lq="-1" aria-label="Decrease quantity">−</button><input type="number" inputmode="numeric" min="0" max="99" value="' + i.quantity + '" data-lqty aria-label="Quantity"><button type="button" data-lq="1" aria-label="Increase quantity">+</button></div></div>' +
              '<div class="kcw-li__r"><b>' + money(i.final_line_price) + '</b><button type="button" data-remove>' + esc(cfg('remove', 'Remove')) + '</button></div></div>';
          }).join('') : '<div class="kcw-drawer__empty"><b>' + esc(cfg('drawer-empty-title')) + '</b>' + esc(cfg('drawer-empty-text')) + '</div>';
        }
      }
    }
    var hdr = doc.getElementById('kc-hdr-cart-count');
    if (hdr) { hdr.textContent = n; hdr.hidden = !n; }
    $$('[data-row]').forEach(function (row) {
      var parts = [];
      $$('[data-opt]', row).forEach(function (o) {
        var q = 0;
        cart.items.forEach(function (i) { if (String(i.variant_id) === o.getAttribute('data-vid')) q += i.quantity; });
        if (q) parts.push(q + ' × ' + o.getAttribute('data-label'));
      });
      row.classList.toggle(IN, parts.length > 0);
      var box = $('[data-in]', row);
      if (box) {
        box.hidden = !parts.length;
        var root = row.closest('[data-kcw="products"]');
        $('span', box).textContent = fill(root.getAttribute('data-t-in'), { list: parts.join(', ') });
      }
    });
  }
  function refresh() {
    return request('cart.js').then(function (c) {
      cart = c;
      paint();
      doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c, source: 'kc-wc' } }));
      return c;
    });
  }
  function fail(err, fallback) {
    toast((err && err.shop && err.description) || fallback || cfg('error'));
  }
  function add(items, message, btn, added) {
    if (btn) btn.disabled = true;
    return request('cart/add.js', { items: items }).then(refresh).then(function () {
      if (btn) btn.disabled = false;
      if (message) toast(message);
      flash(btn, added);
    }).catch(function (err) {
      if (btn) btn.disabled = false;
      fail(err, btn && btn.closest('[data-kcw="products"]') ? btn.closest('[data-kcw="products"]').getAttribute('data-t-error') : '');
    });
  }
  function refocus(key, sel) {
    var l = layer(), d = l && $('[data-drawer]', l);
    if (!d || !d.classList.contains(ON)) return;
    var li = $$('[data-li]', d).filter(function (x) { return x.getAttribute('data-li') === key; })[0];
    var el = (li && sel && $(sel, li)) || $('[data-close]', d);
    if (el) el.focus();
  }
  function change(key, quantity, sel) {
    return request('cart/change.js', { id: key, quantity: Math.max(0, Math.min(99, quantity)) }).then(refresh).then(function () { refocus(key, sel); }).catch(fail);
  }

  function selected(row) { return $('[data-opt][aria-checked="true"]', row); }
  function pick(row, opt) {
    $$('[data-opt]', row).forEach(function (o) {
      var on = o === opt;
      o.classList.toggle(ON, on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
    updateRow(row);
  }
  function updateRow(row) {
    var root = row.closest('[data-kcw="products"]');
    var o = selected(row), addBtn = $('[data-add]', row), qtyInput = $('[data-qty]', row);
    if (!root || !addBtn) return;
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var sizes = row.getAttribute('data-mode') === 'sizes';
    var per = parseFloat(row.getAttribute('data-per')) || 0;
    if (sizes) {
      $$('[data-opt]', row).forEach(function (x) {
        var ml = parseFloat(x.getAttribute('data-ml')) || 0, note = $('[data-opt-note]', x);
        if (note) note.textContent = per > 0 && ml > 0 ? fill(T('sessions'), { n: Math.round(ml / per) }) : '';
      });
    }
    var stock = $('[data-stock]', row);
    if (!o) {
      addBtn.disabled = true;
      addBtn.textContent = T('soldout');
      if (stock) stock.textContent = T('soldout');
      row.classList.add('kcw-is-out');
      return;
    }
    var price = parseInt(o.getAttribute('data-price'), 10) || 0;
    var units = parseInt(o.getAttribute('data-units'), 10) || 0;
    var label = o.getAttribute('data-label');
    var q = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
    var earn = $('[data-earn]', row), cover = $('[data-cover]', row);
    var shelfOn = shelf > 0 && $('[data-shelf]') !== null;
    if (sizes) {
      $('[data-price]', row).textContent = money(price);
      $('[data-price-note]', row).textContent = fill(T('per-size'), { size: label });
      var ml = parseFloat(o.getAttribute('data-ml')) || 0;
      if (per > 0 && ml > 0) {
        earn.hidden = false;
        $('[data-earn-label]', row).textContent = fill(T('session'), { ml: per });
        $('[data-earn-value]', row).textContent = money(Math.round(price / (ml / per)));
      } else earn.hidden = true;
      cover.hidden = true;
    } else {
      var unit = units > 0 ? Math.round(price / units) : price;
      $('[data-price]', row).textContent = money(unit);
      $('[data-price-note]', row).textContent = T('per-unit');
      if (shelfOn && shelf > unit) {
        earn.hidden = false;
        $('[data-earn-label]', row).textContent = fill(T('keep'), { price: money(shelf) });
        $('[data-earn-value]', row).textContent = fill(T('keep-value'), { amount: money(shelf - unit) });
        cover.hidden = false;
        cover.textContent = fill(T('cover'), { n: Math.ceil(price / shelf), price: money(shelf), pack: label });
      } else { earn.hidden = true; cover.hidden = true; }
    }
    if (!addBtn.classList.contains(ADDED)) {
      addBtn.textContent = fill(T('add'), { pack: (q > 1 ? q + ' × ' : '') + label }) + ' · ' + money(price * q);
    }
  }
  function initRows() {
    var first = $('[data-kcw="products"][data-shelf]');
    if (first && !shelf) shelf = parseInt(first.getAttribute('data-shelf'), 10) || 0;
    $$('[data-row]').forEach(function (row) {
      if (!$('[data-buy]', row)) return;
      var opts = $$('[data-opt]', row), cur = selected(row);
      if (!cur) {
        var want = (row.getAttribute('data-default') || '').toLowerCase().trim();
        var open = opts.filter(function (o) { return !o.disabled; });
        cur = open.filter(function (o) {
          return want && (o.getAttribute('data-units') === want || (o.getAttribute('data-label') || '').toLowerCase() === want);
        })[0] || open[0] || null;
      }
      if (cur) pick(row, cur); else updateRow(row);
    });
  }

  function openDrawer(from) {
    var l = layer(), d = l && $('[data-drawer]', l);
    if (!d) return;
    opener = from || doc.activeElement;
    d.classList.add(ON);
    d.setAttribute('aria-hidden', 'false');
    $('[data-scrim]', l).classList.add(ON);
    doc.documentElement.classList.add('kcw-lock');
    $('[data-close]', d).focus();
  }
  function closeDrawer() {
    var l = layer(), d = l && $('[data-drawer]', l);
    if (!d || !d.classList.contains(ON)) return;
    d.classList.remove(ON);
    d.setAttribute('aria-hidden', 'true');
    $('[data-scrim]', l).classList.remove(ON);
    doc.documentElement.classList.remove('kcw-lock');
    if (opener && opener.isConnected) opener.focus();
  }

  function init() {
    doc.documentElement.classList.add('kcw-page');
    var all = $$('[data-kcw-layer]');
    var fresh = all.filter(function (x) { return x.parentNode !== doc.body; }).pop();
    if (fresh) {
      all.forEach(function (x) { if (x !== fresh) x.remove(); });
      doc.body.appendChild(fresh);
    }
    var l = layer();
    var guestBar = l && !approved() && $('[data-mbar]', l);
    if (guestBar) doc.body.classList.add('kcw-has-bar');
    initRows();
    if (approved()) refresh().catch(function () {});
  }

  doc.addEventListener('click', function (e) {
    var t = e.target.closest('button,a');
    if (!t || !t.closest('.kcw')) return;
    if (t.matches('.kcw [data-checkout][aria-disabled="true"]')) { e.preventDefault(); return; }
    if (t.matches('[data-open-cart]')) { openDrawer(t); return; }
    if (t.matches('[data-close]')) { closeDrawer(); return; }
    if (t.matches('[data-shelf-opt]')) {
      shelf = parseInt(t.getAttribute('data-shelf-opt'), 10) || 0;
      $$('[data-shelf-opt]').forEach(function (b) {
        var on = b.getAttribute('data-shelf-opt') === String(shelf);
        b.classList.toggle(ON, on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      $$('[data-row]').forEach(updateRow);
      return;
    }
    if (t.matches('[data-set],[data-again]')) {
      var items;
      try { items = JSON.parse(t.getAttribute('data-items')); } catch (err) { items = []; }
      if (items.length) add(items, t.getAttribute('data-toast'), t, t.getAttribute('data-added'));
      return;
    }
    if (t.matches('[data-more-add]')) {
      add([{ id: parseInt(t.getAttribute('data-vid'), 10), quantity: 1 }], t.getAttribute('data-toast'), t, t.getAttribute('data-added'));
      return;
    }
    var row = t.closest('[data-row]');
    if (row) {
      var qty = $('[data-qty]', row);
      if (t.matches('[data-opt]')) { pick(row, t); return; }
      if (t.matches('[data-q]')) {
        qty.value = Math.max(1, Math.min(99, (parseInt(qty.value, 10) || 1) + parseInt(t.getAttribute('data-q'), 10)));
        updateRow(row);
        return;
      }
      if (t.matches('[data-add]')) {
        var o = selected(row);
        if (!o) return;
        var root = row.closest('[data-kcw="products"]');
        var q = Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1));
        var name = row.getAttribute('data-name') + ' ' + o.getAttribute('data-label');
        qty.value = 1;
        add([{ id: parseInt(o.getAttribute('data-vid'), 10), quantity: q }], fill(root.getAttribute('data-t-toast'), { qty: q, name: name }), t, root.getAttribute('data-t-added'));
        return;
      }
    }
    var li = t.closest('[data-li]');
    if (li && cart) {
      var key = li.getAttribute('data-li');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      if (t.matches('[data-remove]')) change(key, 0);
      if (t.matches('[data-lq]')) change(key, item.quantity + parseInt(t.getAttribute('data-lq'), 10), '[data-lq="' + t.getAttribute('data-lq') + '"]');
    }
  });
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-row] [data-qty]')) {
      t.value = Math.max(1, Math.min(99, Math.round(parseFloat(t.value)) || 1));
      updateRow(t.closest('[data-row]'));
    }
    if (t.matches && t.matches('[data-lqty]')) change(t.closest('[data-li]').getAttribute('data-li'), Math.round(parseFloat(t.value)) || 0, '[data-lqty]');
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); return; }
    var group = e.target.closest && e.target.closest('.kcw [role="radiogroup"]');
    if (group && ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) > -1) {
      var radios = $$('[role="radio"]', group).filter(function (r) { return !r.disabled; });
      var i = radios.indexOf(e.target);
      if (i < 0) return;
      e.preventDefault();
      var next = radios[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + radios.length) % radios.length];
      next.click();
      next.focus();
      return;
    }
    var l = layer(), d = l && $('[data-drawer]', l);
    if (e.key === 'Tab' && d && d.classList.contains(ON)) {
      var f = $$('button:not([disabled]),input,a[href]', d).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (!d.contains(doc.activeElement)) { e.preventDefault(); f[0].focus(); return; }
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  doc.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('.kcw-scrim')) closeDrawer();
  });
  doc.addEventListener('shopify:section:load', init);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
